import {otsBaseApi} from "../../ots-api";
import {WellStage} from "../../../model/well-stage";

const taggedBaseApi = otsBaseApi.enhanceEndpoints({addTagTypes: ["WellStages"]});

const wellStageApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllWellStages: builder.query<WellStage[], string | undefined>({
      query: (regionId) => ({
        url: `/well-stages/all`,
        method: "GET",
        params: regionId ? {regionId: regionId} : undefined
      }),
      keepUnusedDataFor: 300,
      providesTags: (result) => {
        if (result) {
          return [
            ...result.map(({id}) => ({type: "WellStages", id} as const)),
            {type: "WellStages", id: "LIST"}
          ];
        } else {
          return [{type: "WellStages", id: "LIST"}];
        }
      }
    }),
    getWellStage: builder.query<WellStage, string>({
      query: (id) => ({
        url: `/well/${id}`,
        method: "GET"
      }),
      providesTags: (result, error, id) => [{type: "WellStages", id}]
    }),
  })
});

export const {
  useGetAllWellStagesQuery,
  useGetWellStageQuery,
} = wellStageApi;
